<template>
  <button
    @click="$emit('delete-completed')"
    class="
      ml-auto
      text-xs
      sm:text-sm
      font-normal font-josefin
      text-cleanerText-light
      hover:text-cleanerTxtHover-light
      dark:text-cleanerText-dark
      dark:hover:text-cleanerTxtHover-dark
      transition-all
      duration-300
    "
  >
    Clear Completed
  </button>
</template>
<script>
export default {
  name: "Cleaner",
};
</script>